var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M6.417 6.417h-2.8c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v3.966m10.5 0V3.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127h-2.1c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.126.25-.126.576-.126 1.23v8.633m6.416 0H1.167m7.291-8.167h1.75m-1.75 2.334h1.75M8.458 8.75h1.75"
  })));
};
export default SvgBuilding;